import { Link as LinkLi } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import PropTypes from 'prop-types';
import React, { lazy, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link as LinkDom } from 'react-router-dom';
import TopActions from './TopActions';
import { columns } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);
const Link = lazy(() => import(`globalcomponents/UI/Link`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      {layout !== 'OldUi' && <Breadcrumb filters={filters} />}
      <Component {...contentProps} filters={filters} />
    </Box>
  );
};
export default Index;

const Component = ({
  workOrders,
  filterSuccess,
  Styled,
  history,
  topAction,
  pagination,
  setPagination,
  viewOnly,
  changeRequest,
  request,
  setFilter,
  filter,
}) => {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const filters = useSelector((state) => state.filters);
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const RTFMuser = checkServiceProvider('rtfmUser', SERVICE_PROVIDER, false);

  const generateRows = () => {
    return (
      workOrders.filteredList.map((item) => {
        const isSpireonNewLayout = layout === 'SpireonNew';
        const isRTFMUser = RTFMuser;

        return {
          ...item,
          id: item.work_order_id,
          type: item.type || '-',
          status: item.status?.name,
          work_order_id: (
            <Link
              href={
                viewOnly
                  ? pageUrls.viewWorkOrder.replace(':id', item.work_order_id)
                  : pageUrls.editWorkOrder.replace(':id', item.work_order_id)
              }
            >
              {item.work_order_id}
            </Link>
          ),
          unitId:
            isSpireonNewLayout || isRTFMUser ? (
              item.unitId
            ) : (
              <Link href={`/${item.unitType === 'TRAILER' ? 'trailer' : 'vehicle'}/edit/${item.unit_id?.id}`}>{item.unitId}</Link>
            ),
          mechanicName: <Link href={pageUrls.editUser.replace(':id', item.mechanic?.id)}>{item.mechanicName}</Link>,
          driverName: isRTFMUser ? (
            item.driverName
          ) : (
            <Link href={pageUrls.editUser.replace(':id', item.driver?.id)}>{item.driverName}</Link>
          ),
          report: item.inspection_report?.id ? (
            <Link
              onClick={() =>
                dispatch.viewReport.viewReportDocument({
                  apiId: 'viewReportApi',
                  data: item.inspection_report.id,
                })
              }
            >
              {i18n.t('workOrders.viewReport')}
            </Link>
          ) : (
            i18n.t('workOrders.noReport')
          ),
        };
      }) || []
    );
  };

  useEffect(() => {
    generateRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workOrders?.filteredList]);

  const filterByStatus = (status) => {
    setFilter(status);
  };
  const information = i18n.t('common.tableEmptyMessage');
  return (
    <>
      <Styled.Wrapper>
        {topAction && (
          <TopActions
            {...{
              filterSuccess,
              Styled,
              workOrders,
              i18n,
              history,
              setPagination,
              viewOnly,
            }}
          />
        )}
        <div className="status-wrapper">
          <span className="quickFilters">Quick filters:</span>
          <FormStyle.default.ButtonsWrapper className="openFilter">
            <Button
              type="submit"
              className={filter == 'OPEN' ? 'buttonStyle filter-btn' : 'buttonStyle'}
              label={i18n.t('workOrders.open')}
              onClick={() => {
                filterByStatus('OPEN');
              }}
            />
          </FormStyle.default.ButtonsWrapper>
          <FormStyle.default.ButtonsWrapper>
            <Button
              type="submit"
              className={filter == 'CLOSED' ? 'buttonStyle filter-btn' : 'buttonStyle'}
              label={i18n.t('workOrders.closed')}
              onClick={() => {
                filterByStatus('CLOSED');
              }}
            />
          </FormStyle.default.ButtonsWrapper>
        </div>
        <div className="breadcrumbClass">{layout === 'OldUi' && <Breadcrumb filters={filters} />}</div>
        <Styled.TableWrapper>
          <Table
            type="server"
            defaultSortBy={{ sortBy: 'work_order_id', order: 'desc' }}
            title=""
            baseRequest={request}
            totalRecords={workOrders.totalCount}
            changeRequest={changeRequest}
            columns={[...columns]}
            data={generateRows()}
            emptyMessage={information}
            actions={[
              {
                icon: (row, index) => {
                  return (
                    <LinkLi
                      component={LinkDom}
                      to={viewOnly ? pageUrls.viewWorkOrder.replace(':id', row.id) : pageUrls.editWorkOrder.replace(':id', row.id)}
                    >
                      <>{viewOnly ? <VisibilityIcon className="historyIcon" /> : <Icon src={mediaUrls?.edit} />}</>
                    </LinkLi>
                  );
                },
              },
            ]}
            itemsPerPage={10}
            i18n={i18n}
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
          />
        </Styled.TableWrapper>
      </Styled.Wrapper>
    </>
  );
};

Component.propTypes = {
  filterSuccess: PropTypes.func.isRequired,
};
